import {
    getBlockUsersRepo, getBlockUsersSearchRepo, postBlockUsersRepo, postUserLogoutRepo
} from "../repositories/premium/permission";
import { createSlice } from "@reduxjs/toolkit";

const blockUsersSlice = createSlice({
    name: "blockUsersReducer",
    initialState: {
        // search/drop-down data
        searchUsersLoading: false,
        searchUsers: null,
        searchUsersError: null,

        // list of data 
        blockUsersLoading: false,
        blockUsers: null,
        blockUsersError: null,

        postBlockUsersLoading: false,
        postBlockUsersData: null,
        postBlockUsersError: null,

        postUserLogoutLoading:false,
        postUserLogout:null,
        postUserLogoutError:null,

        message:null
    },
    reducers: {

        // list data
        getBlockUsersLoading(state, action) {
            return {
                ...state,
                blockUsersLoading: true,
            };
        },
        getBlockUsersSuccess(state, action) {
            return {
                ...state,
                blockUsersLoading: false,
                blockUsers: action.payload,
            };
        },
        getBlockUsersFailure(state, action) {
            return {
                ...state,
                blockUsersLoading: false,
                blockUsersError: action.payload,
            };
        },

        getBlockUsersClear(state, action) {
            return {
                ...state,
                blockUsers: null,
            };
        },

        // drop down data
        getSearchUsersLoading(state, action) {
            return {
                ...state,
                searchUsersLoading: true,
            };
        },
        getSearchUsersSuccess(state, action) {
            return {
                ...state,
                searchUsersLoading: false,
                searchUsers: action.payload,
            };
        },
        getSearchUsersFailure(state, action) {
            return {
                ...state,
                searchUsersLoading: false,
                searchUsersError: action.payload,
            };
        },

        postBlockUsersLoading(state, action) {
            return {
                ...state,
                postBlockUsersLoading: true,
            };
        },
        postBlockUsersSuccess(state, action) {
            return {
                ...state,
                postBlockUsersLoading: false,
                postBlockUsersData: action.payload,
                message:"Changes are saved successfully"
            };
        },
        postBlockUsersFailure(state, action) {
            return {
                ...state,
                postBlockUsersLoading: false,
                postBlockUsersError: action.payload,
                message: "Failure in Changing Block User",
            };
        },

        postUserLogoutLoading(state, action) {
            return {
                ...state,
                postUserLogoutLoading: true,
            };
        },
        postUserLogoutSuccess(state, action) {
            return {
                ...state,
                postUserLogoutLoading: false,
                postUserLogout: action.payload,
            };
        },
        postUserLogoutFailure(state, action) {
            return {
                ...state,
                postUserLogoutLoading: false,
                postUserLogoutError: action.payload,
            };
        },

        clearSearchUser(state,action){
            return{
                ...state,
                searchUsers:null
            }
        },
        clearBlockUserMessage(state,action){
            return {
                ...state,
                message:null,
                postBlockUsersError:null
            }
        }
    },
});
export const {
    // drop down data 
    getSearchUsersLoading,
    getSearchUsersSuccess,
    getSearchUsersFailure,

    // list data 
    getBlockUsersLoading,
    getBlockUsersSuccess,
    getBlockUsersFailure,
    getBlockUsersClear,       // for refresh the page

    postBlockUsersLoading,
    postBlockUsersSuccess,
    postBlockUsersFailure,

    postUserLogoutLoading,
    postUserLogoutSuccess,
    postUserLogoutFailure,

    clearSearchUser,
    clearBlockUserMessage

} = blockUsersSlice.actions;

// drop down data
export const getSearchUsers = (params) => {
    return async (dispatch) => {
        dispatch(getSearchUsersLoading());
        await getBlockUsersSearchRepo(params)
            .then((response) => {
                if (response?.status == 200 ||
                    response?.status == 201){
                    dispatch(getSearchUsersSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getSearchUsersFailure(error.message));
                }
            });
    };
};

// table data 
export const getBlockUsers = (params) => {
  return async (dispatch) => {
    dispatch(getBlockUsersLoading());
    await getBlockUsersRepo(params)
      .then((response) => {
        if (
          response?.status == 200 ||
          response?.status == 201 
        ) {
          dispatch(getBlockUsersSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getBlockUsersFailure(error.message));
        }
      });
  };
};

// on save of Table Data
export const postBlockUsers = (params) => {
    return async (dispatch) => {
        dispatch(postBlockUsersLoading());
        await postBlockUsersRepo(params)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 
                ) {
                    dispatch(postBlockUsersSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postBlockUsersFailure(error.message));
                }
            });
    };
};

export const postUserlogout = (data) => {
    return async (dispatch) => {
      dispatch(postUserLogoutLoading());
      await postUserLogoutRepo(data)
        .then((response) => {
          if (response.status >= 200 && response.status <= 300){
            dispatch(postUserLogoutSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(postUserLogoutFailure(error.message));
          }
        });
    };
  };

export default blockUsersSlice.reducer;